import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { ArrowRight } from '@hhgtech/icons/other'
import { AspectRatio, Box, BoxProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { useHandlerUrls } from 'hooks/useHandlerUrls'

import useStyles from './index.styles'

type Props = {
  heading?: string
  content?: string
  image?: string
  ctaTitle?: string
  ctaUrl?: string
} & BoxProps

export const AdditionalInfo = ({
  heading,
  content,
  image,
  ctaTitle,
  ctaUrl,
  styles,
  className,
  classNames,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(undefined, {
    name: 'AdditionalInfo',
    styles,
    classNames,
  })
  const linkData = useHandlerUrls(ctaUrl ? [ctaUrl] : [])
  const { isExternalUrl } = linkData?.[0] || {}
  const commonHref = {
    href: ctaUrl,
    target: isExternalUrl ? '_blank' : '_self',
    className: 'pointer-event-child-none',
    'data-event-category': 'Health Tool',
    'data-event-action': 'Additional Information',
    'data-event-label': ctaUrl,
  }
  return heading || content ? (
    <Box className={cx(className, classes.root)}>
      {image && (
        <Box
          component={ctaUrl ? 'a' : 'div'}
          className={classes.thumbnail}
          {...(ctaUrl && commonHref)}
        >
          <AspectRatio ratio={192 / 128}>
            <img
              loading="lazy"
              src={image}
              alt={heading}
              className={classes.thumbnailImg}
            />
          </AspectRatio>
        </Box>
      )}
      <Box className={classes.info}>
        {heading && <Text size="s2">{heading}</Text>}
        {content && <Text size="p4">{content}</Text>}
        {ctaUrl && (
          <a {...commonHref}>
            <Button
              classNames={{
                root: classes.btn,
                icon: classes.btnIcon,
              }}
              rightIcon={<ArrowRight size={18} useCurrentColor />}
            >
              {ctaTitle || f({ id: 'articlePage.readMore' })}
            </Button>
          </a>
        )}
      </Box>
    </Box>
  ) : null
}
